"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeToArray = function (array) { return function (subscriber) {
    for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
        subscriber.next(array[i]);
    }
    subscriber.complete();
}; };
//# sourceMappingURL=subscribeToArray.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/rxjs/internal/util/subscribeToArray.js
// module id = 907
// module chunks = 12